module.exports = __webpack_public_path__ + "img/logo.b77bee81.svg";